(function () {
  const fallbackRates = {
    AUD: 1,
    USD: 0.714324,
    NZD: 1.216736,
    CAD: 0.983671,
    GBP: 0.531885,
    EUR: 0.615069,
    SGD: 0.913097,
    JPY: 113.585103,
    KRW: 1074.813481,
    CNY: 4.858755,
    HKD: 5.594322,
    PKR: 199.406494,
    INR: 68.716704,
    AED: 2.623032
  };

  const countryCurrency = {
    AU: "AUD",
    US: "USD",
    NZ: "NZD",
    CA: "CAD",
    GB: "GBP",
    IE: "EUR",
    FR: "EUR",
    DE: "EUR",
    IT: "EUR",
    ES: "EUR",
    SG: "SGD",
    JP: "JPY",
    KR: "KRW",
    CN: "CNY",
    HK: "HKD",
    PK: "PKR",
    IN: "INR",
    AE: "AED"
  };

  const collectionLabels = {
    all: "Pokemon - All languages",
    pokemon: "Pokemon - All languages",
    "pokemon-japanese": "Pokemon - Japanese",
    "pokemon-korean": "Pokemon - Korean",
    "pokemon-chinese": "Pokemon - Chinese",
    "pokemon-english": "Pokemon - English",
    "pokemon-graded": "Pokemon - Graded Cards",
    "one-piece": "One Piece - All languages",
    "one-piece-japanese": "One Piece - Japanese",
    "one-piece-korean": "One Piece - Korean",
    "one-piece-chinese": "One Piece - Chinese",
    "one-piece-english": "One Piece - English",
    "one-piece-graded": "One Piece - Graded Cards",
    future: "Future collections"
  };

  const state = {
    nav: "all",
    query: "",
    status: "all",
    sort: "featured",
    currency: "AUD",
    rates: { ...fallbackRates }
  };

  function refreshIcons() {
    if (window.lucide) {
      window.lucide.createIcons();
    }
  }

  function detectCurrency() {
    const locale = navigator.languages?.[0] || navigator.language || "en-AU";
    const country = locale.split("-")[1]?.toUpperCase();
    return countryCurrency[country] || "AUD";
  }

  function navMatches(product, nav) {
    if (nav === "all" || nav === "pokemon") return product.genre === "Pokemon";
    if (nav === "pokemon-korean") return product.genre === "Pokemon" && product.language === "Korean";
    if (nav === "pokemon-chinese") return product.genre === "Pokemon" && product.language === "Chinese";
    if (nav === "pokemon-japanese" || nav === "pokemon-english" || nav === "pokemon-graded") return false;
    if (nav.startsWith("one-piece") || nav === "future") return false;
    return true;
  }

  function formatPrice(cents) {
    const rate = state.rates[state.currency] || 1;
    const value = (Number(cents || 0) / 100) * rate;
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: state.currency,
      maximumFractionDigits: ["JPY", "KRW", "IDR"].includes(state.currency) ? 0 : 2
    }).format(value);
  }

  function getVisibleProducts(products) {
    const query = state.query.trim().toLowerCase();
    let visible = products.filter((product) => navMatches(product, state.nav));

    if (state.status !== "all") {
      visible = visible.filter((product) => product.status === state.status);
    }

    if (query) {
      visible = visible.filter((product) => {
        const searchable = `${product.title} ${product.genre} ${product.language} ${product.status}`.toLowerCase();
        return searchable.includes(query);
      });
    }

    return visible.sort((a, b) => {
      if (state.sort === "price-low") return a.priceCents - b.priceCents;
      if (state.sort === "price-high") return b.priceCents - a.priceCents;
      if (state.sort === "name") return a.title.localeCompare(b.title);
      return a.index - b.index;
    });
  }

  async function updateCartCount() {
    const cartCount = document.querySelector("#cartCount");
    if (!cartCount) return;

    try {
      const response = await fetch(window.oneoutTheme?.cartJsonUrl || "/cart.js", {
        headers: { Accept: "application/json" }
      });
      if (!response.ok) return;
      const cart = await response.json();
      cartCount.textContent = String(cart.item_count || 0);
    } catch (error) {
      return;
    }
  }

  function setupCatalog() {
    const catalog = document.querySelector("[data-oneout-catalog]");
    if (!catalog) {
      refreshIcons();
      return;
    }

    const productGrid = catalog.querySelector("#productGrid");
    const resultCount = catalog.querySelector("#resultCount");
    const activeCollection = catalog.querySelector("#activeCollection");
    const emptyState = catalog.querySelector("#emptyState");
    const searchInput = catalog.querySelector("#searchInput");
    const statusFilter = catalog.querySelector("#statusFilter");
    const sortSelect = catalog.querySelector("#sortSelect");
    const rateStatus = catalog.querySelector("#rateStatus");

    const products = Array.from(catalog.querySelectorAll(".product-card")).map((element) => ({
      element,
      title: element.dataset.title || "",
      genre: element.dataset.genre || "Pokemon",
      language: element.dataset.language || "Korean",
      status: element.dataset.status || "Factory Sealed",
      priceCents: Number(element.dataset.priceCents || 0),
      index: Number(element.dataset.index || 0),
      priceNode: element.querySelector("[data-price]")
    }));

    function renderProducts() {
      const visible = getVisibleProducts(products);
      const visibleSet = new Set(visible.map((product) => product.element));

      visible.forEach((product) => {
        product.element.hidden = false;
        if (product.priceNode) product.priceNode.textContent = formatPrice(product.priceCents);
        productGrid.appendChild(product.element);
      });

      products.forEach((product) => {
        if (!visibleSet.has(product.element)) product.element.hidden = true;
      });

      productGrid.hidden = visible.length === 0;
      emptyState.hidden = visible.length !== 0;
      resultCount.textContent = `${visible.length} ${visible.length === 1 ? "item" : "items"}`;
      activeCollection.textContent = collectionLabels[state.nav] || collectionLabels.all;
      refreshIcons();
    }

    function setNav(nav) {
      state.nav = nav;
      document.querySelectorAll("[data-nav]").forEach((button) => {
        button.classList.toggle("is-active", button.dataset.nav === nav || (nav === "all" && button.dataset.nav === "pokemon"));
      });
      renderProducts();
    }

    document.querySelectorAll("[data-nav]").forEach((button) => {
      button.addEventListener("click", () => setNav(button.dataset.nav));
    });

    document.querySelectorAll("[data-density]").forEach((button) => {
      button.addEventListener("click", () => {
        const compact = button.dataset.density === "compact";
        productGrid.classList.toggle("compact", compact);
        document.querySelectorAll("[data-density]").forEach((control) => {
          control.classList.toggle("is-active", control === button);
        });
      });
    });

    searchInput?.addEventListener("input", (event) => {
      state.query = event.target.value;
      renderProducts();
    });

    document.querySelector("#searchToggle")?.addEventListener("click", () => {
      searchInput?.focus();
    });

    statusFilter?.addEventListener("change", (event) => {
      state.status = event.target.value;
      renderProducts();
    });

    sortSelect?.addEventListener("change", (event) => {
      state.sort = event.target.value;
      renderProducts();
    });

    document.querySelectorAll(".add-form").forEach((form) => {
      form.addEventListener("submit", async (event) => {
        event.preventDefault();
        const button = form.querySelector(".add-button");
        const variantId = form.querySelector('input[name="id"]')?.value;
        if (!variantId || button?.disabled) return;

        const original = button.innerHTML;
        button.disabled = true;
        button.textContent = "Adding";

        try {
          const response = await fetch(window.oneoutTheme?.cartAddUrl || "/cart/add", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 })
          });
          if (!response.ok) throw new Error("Could not add item");
          button.textContent = "Added";
          await updateCartCount();
          window.setTimeout(() => {
            button.disabled = false;
            button.innerHTML = original;
            refreshIcons();
          }, 900);
        } catch (error) {
          button.disabled = false;
          button.textContent = "Try again";
          window.setTimeout(() => {
            button.innerHTML = original;
            refreshIcons();
          }, 1200);
        }
      });
    });

    async function loadRates() {
      try {
        const response = await fetch("https://open.er-api.com/v6/latest/AUD");
        if (!response.ok) throw new Error("Rate service unavailable");
        const data = await response.json();
        if (data.result !== "success" || !data.rates) throw new Error("Rate payload invalid");
        state.rates = { ...fallbackRates, ...data.rates, AUD: 1 };
        rateStatus.textContent = "Live AUD rates loaded";
      } catch (error) {
        rateStatus.textContent = "Using saved AUD rates";
      } finally {
        renderProducts();
      }
    }

    setNav("all");
    loadRates();
  }

  function setupCurrencyControls() {
    const currencySelect = document.querySelector("#currencySelect");
    if (!currencySelect) return;

    currencySelect.addEventListener("change", (event) => {
      state.currency = event.target.value;
      document.querySelector("[data-oneout-catalog] #sortSelect")?.dispatchEvent(new Event("change"));
      document.querySelectorAll("[data-price]").forEach((priceNode) => {
        const card = priceNode.closest(".product-card");
        if (card) priceNode.textContent = formatPrice(card.dataset.priceCents);
      });
    });

    document.querySelector("#localCurrencyBtn")?.addEventListener("click", () => {
      const localCurrency = detectCurrency();
      currencySelect.value = localCurrency;
      state.currency = currencySelect.value || "AUD";
      currencySelect.dispatchEvent(new Event("change"));
    });
  }

  window.addEventListener("DOMContentLoaded", () => {
    setupCurrencyControls();
    setupCatalog();
  });
})();
;document.addEventListener("DOMContentLoaded",function(){var m=[["/pages/shipping-policy","/pages/shipping-policy","Shipping Policy"],["/pages/returns-refunds","/pages/returns-refunds-policy","Returns & Refunds Policy"],["/pages/faq","/pages/faq","FAQ"],["/pages/contact-us","/pages/contact-us","Contact Us"]];document.querySelectorAll(".primary-nav a").forEach(function(a){var h=a.getAttribute("href")||"",x=m.find(function(i){return h.indexOf(i[0])>-1});if(!x)return;a.classList.remove("nav-page-link");a.classList.add("nav-link");a.setAttribute("href",x[1]);a.textContent=x[2];});});

